import { Capacitor } from '@capacitor/core';

// Helper function to test cordova.exec
const testCordovaExec = (service: string, action: string, params: any[] = []): Promise<any> => {
  if (!window.cordova || !window.cordova.exec) {
    
    return Promise.resolve(null);
  }
  
  return new Promise((resolve) => {
    try {
      
      window.cordova.exec(
        (result: any) => {
          
          resolve(result);
        },
        (error: any) => {
          
          resolve(null);
        },
        service,
        action,
        params
      );
    } catch (e) {
      
      resolve(null);
    }
  });
};

/**
 * Utility function to test the OneSignal plugin
 */
export const testOneSignalPlugin = async () => {
  if (!Capacitor.isNativePlatform()) {
    
    return;
  }

  // Check for Cordova
  if (window.cordova) {
    
    
    
    if (window.cordova.exec) {
      
    } else {
      
    }
  } else {
    
  }

  // Check if plugins object exists
  if (!window.plugins) {
    
    return;
  } else {
    
  }

  // Check OneSignal availability
  if (!window.plugins.OneSignal) {
    
    return;
  } else {
    
  }

  // Log available methods
  
  
  const methods = Object.getOwnPropertyNames(window.plugins.OneSignal);
  
  
  // Try testing Cordova exec commands directly
  if (window.cordova && window.cordova.exec) {
    
    
    // Test different service name possibilities (might be OneSignalPush or OneSignal)
    const potentialServiceNames = ['OneSignalPush', 'OneSignal'];
    
    for (const serviceName of potentialServiceNames) {
      
      
      // First test if the service exists
      const serviceTestResult = await testCordovaExec(serviceName, 'test', []);
      const isServiceAvailable = (serviceTestResult !== null) || 
                               (serviceName === 'OneSignalPush'); // Special case for OneSignalPush which might not have 'test'
      
      if (isServiceAvailable) {
        
        
        // Test OneSignal service with legacy Cordova method names
        const testActions = [
          'getPermissionSubscriptionState',
          'promptForPushNotificationsWithUserResponse',
          'setSubscription',
          'handleNotificationOpened',
          'handleNotificationReceived',
          'init'
        ];
        
        // Test with proper parameters for each method
        for (const action of testActions) {
          try {
            let params: any[] = [];
            
            // Set appropriate test parameters for each method
            if (action === 'init') {
              // Test with your app ID directly as a string parameter
              const testAppId = import.meta.env.VITE_ONESIGNAL_APP_ID || '11590e68-9cfc-46e1-9b45-00d603e9d1d4';
              params = [testAppId];
            } else if (action === 'setSubscription') {
              // true enables notifications
              params = [true];
            } else if (action === 'promptForPushNotificationsWithUserResponse') {
              // false means don't fallback to settings
              params = [false];
            }
            
            
            const result = await testCordovaExec(serviceName, action, params);
            
            if (result !== null) {
              
            }
          } catch (e) {
            
          }
        }
        
        // If we found a working service, no need to try the other one
        break;
      } else {
        
      }
    }
  }
  
  // Check if we have SDK 5.x structure
  const isSDK5 = window.plugins.OneSignal.User && window.plugins.OneSignal.Notifications;
  
  if (isSDK5) {
    
    
    // Test SDK 5.x specific methods
    if (window.plugins.OneSignal.Notifications) {
      
      
      // Test specific methods in the Notifications namespace
      const notificationMethods = [
        'requestPermission',
        'setForegroundWillDisplayHandler',
        'setNotificationOpenedHandler',
        'disablePush'
      ];
      
      notificationMethods.forEach(method => {
        if (typeof window.plugins.OneSignal.Notifications[method] === 'function') {
          
        } else {
          
        }
      });
    } else {
      
    }
    
    if (window.plugins.OneSignal.User) {
      
      
      // Test specific methods in the User namespace
      const userMethods = [
        'getPushSubscription',
        'getExternalUserId'
      ];
      
      userMethods.forEach(method => {
        if (typeof window.plugins.OneSignal.User[method] === 'function') {
          
        } else {
          
        }
      });
    } else {
      
    }
  } else {
    // Test legacy methods
    // Try to get the OneSignal SDK version if possible
    if (typeof window.plugins.OneSignal.getDeviceState === 'function') {
      
    } else {
      
    }
    
    if (typeof window.plugins.OneSignal.disablePush === 'function') {
      
    } else {
      
    }
    
    // Additional tests for each expected method
    [
      'setAppId', 
      'promptForPushNotificationsWithUserResponse',
      'setNotificationWillShowInForegroundHandler',
      'setNotificationOpenedHandler',
      'getDeviceState',
      'disablePush'
    ].forEach(method => {
      if (typeof window.plugins.OneSignal[method] === 'function') {
        
      } else {
        
      }
    });
  }
  
  
}; 